import { client } from '../../apollo'
import {
  RetailerNexusLocations,
  RetailerNexusLocationsResponse,
} from '../../queries/calculate-tax'
import { EntityStore } from './entity-store'

const AUTOTAX_SETTINGS_KEY = 'AUTOTAX_SETTINGS'

export interface AutotaxSettings {
  isDeliveryTaxEnabled: boolean
}

export class AutotaxSettingsStore extends EntityStore<'settings'> {
  constructor() {
    super({
      entityName: 'autotax_settings',
      entityStoreName: 'autotaxSettings',
      databaseStoreName: 'settings',
    })
  }

  public get() {
    return super.get(AUTOTAX_SETTINGS_KEY)
  }

  public requestSyncData(entitySyncConfig: $TSFixMe) {
    const maxVersion = entitySyncConfig.data.entityVersion.maxVersion
    const lastSyncedVersion =
      entitySyncConfig.data.entityVersion.lastSyncedVersion

    if (lastSyncedVersion >= maxVersion) {
      return Promise.resolve({
        data: [],
        version: { min: maxVersion, max: maxVersion },
      })
    }

    return client
      .query<RetailerNexusLocationsResponse>({
        query: RetailerNexusLocations,
        fetchPolicy: 'network-only',
      })
      .then(result => ({
        data: [
          {
            isDeliveryTaxEnabled:
              result.data?.retailerNexusLocations?.isDeliveryTaxEnabled ??
              false,
          },
        ],
        version: { min: maxVersion, max: maxVersion },
      }))
      .catch(() => ({
        data: [],
        version: { min: maxVersion, max: maxVersion },
      }))
  }

  public syncData(data: AutotaxSettings[]) {
    const settings = data && data[0]
    if (!settings) {
      return super.syncData([])
    }
    return this.dbStore
      .put(AUTOTAX_SETTINGS_KEY, settings)
      .then(() => this.emitSyncEvent({ removed: [], updated: [settings] }))
  }
}

export const autotaxSettingsStore = new AutotaxSettingsStore()
